import httpClient from './http-client';
import mockInstitutionService from './institution.service.mock';

let institutionService;

if (process.env.NODE_ENV === 'development') {
  institutionService = mockInstitutionService;
} else {
  institutionService = {
    getInstitutions(params) {
      return httpClient.get('/institution', { params });
    },
  };
}

export default institutionService;
